import { DOMAdapter, Texture } from "pixi.js";

export type { OwnedImageAsset } from "./imageAssetManager";
export { acquireOwnedImageAsset } from "./imageAssetManager";

import type { ImageOverlaySource } from "./types";

type PlaceholderStatus = Exclude<ImageOverlaySource["status"], "image">;

const PLACEHOLDER_SIZE = 64;
const placeholderTextures: Partial<Record<PlaceholderStatus, Texture>> = {};

function createPlaceholderTexture(status: PlaceholderStatus): Texture {
    const canvas = DOMAdapter.get().createCanvas(
        PLACEHOLDER_SIZE,
        PLACEHOLDER_SIZE,
    );
    const context = canvas.getContext("2d");
    if (!context) return Texture.WHITE;

    const colors = {
        loading: { background: "#88888888", detail: null },
        unavailable: { background: "#555a5f", detail: "#aeb4ba" },
        deleted: { background: "#552b2b", detail: "#b55252" },
    } as const;
    const { background, detail } = colors[status];

    context.fillStyle = background;
    context.fillRect(0, 0, PLACEHOLDER_SIZE, PLACEHOLDER_SIZE);
    if (detail === null) return Texture.from(canvas);

    context.strokeStyle = detail;
    context.lineWidth = 8;

    context.beginPath();
    context.moveTo(8, 8);
    context.lineTo(PLACEHOLDER_SIZE - 8, PLACEHOLDER_SIZE - 8);
    context.moveTo(PLACEHOLDER_SIZE - 8, 8);
    context.lineTo(8, PLACEHOLDER_SIZE - 8);
    context.stroke();

    return Texture.from(canvas);
}

export function getPlaceholderTexture(status: PlaceholderStatus): Texture {
    const existing = placeholderTextures[status];
    if (existing) return existing;

    const texture = createPlaceholderTexture(status);
    placeholderTextures[status] = texture;
    return texture;
}
